module.exports = __webpack_public_path__ + "img/four4Green.f3be2df0.png";